import { NavigationTab } from '../topNavigation/constants/navigationConstants';

// NOTE (@mbae, 03/26/25): Use this only if you have a NavigationTab
// Otherwise, you can just use `${getCreatorHubBasePath(target, environment)}${yourPath}`
export const getTabWithComputedHref = (tab: NavigationTab, originUrl?: string) => {
  const newTab = { ...tab };
  if (originUrl && newTab.path && newTab.tabPath) {
    newTab.href = originUrl;
  } else if (originUrl && newTab.path) {
    newTab.href = `${originUrl}${newTab.path}`;
  } else if (originUrl && newTab.key === 'Forum' && newTab.href.includes('sitetest')) {
    // NOTE(@rvaughan, 02-02-2024): DevForum doesn't have a path attribute, so we have to replace the sitetest environment in the href
    const sitetestEnvironment = originUrl.match(/sitetest(\d)/);
    if (sitetestEnvironment) {
      newTab.href = newTab.href.replace(/sitetest\d/, `sitetest${sitetestEnvironment[1]}`);
    }
  }

  return newTab;
};

/**
 * We replace the `href` property of a tab with the correct `href`
 * based on the origin and path of the tab. If a path or origin
 * isn't specified, then we stick with the current `href` value
 *
 * @param environment Environment of the Creator Hub app
 * @param rawTabs Tabs to convert
 * @param originUrl Origin URI to use
 * @returns A new copy of the tabs with a potentially new value for href
 */
export const useTabsWithComputedHref = (rawTabs: NavigationTab[], originUrl?: string) => {
  // NOTE (mbae 09/19/23): For some reason we can't memoize this (from PR https://github.rbx.com/Roblox/unified-creator-site/pull/144)
  const tabsWithPath: NavigationTab[] = rawTabs.map(tab => {
    return getTabWithComputedHref(tab, originUrl);
  });

  return tabsWithPath;
};
